import { orderDetail } from "../../../../api/testataordine";
import TabDatifatt from "../dettaglio/TabDatifatt";
import TabProdotto from "../dettaglio/TabProdotto";
import TabStampe from "../dettaglio/TabStampe";
import TabStep1 from "../dettaglio/TabStep1";
import TabTracking from "../dettaglio/TabTracking";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from '../../../../lib/traduzioni';
import TabPagamenti from "../dettaglio/TabPagamenti";
const {logger} = useBSSLogger();

const defaultStatoMenu = {anchorEl: null, open: false, ordine: null};

const orderHrefBuilder = ({ordine, paginaOrdini = null, tab = 0}) => {
    const idPaginaOrdine = spedizioniweb2?.paginepreventivo?.step5  ?? null;

    const paginaOrdiniDefault = (idPaginaOrdine !== null) ? (spedizioniweb2?.pagine?.[Number(idPaginaOrdine)].link ?? null) : null;
    
    if(paginaOrdini === null){
        paginaOrdini = paginaOrdiniDefault ?? location.href;
    }
    let url = new URL(paginaOrdini);
    let searchObj = url.searchParams;
    searchObj.set("ordine", ordine.codiceordine);
    if(tab !== 0){
        searchObj.set("tab", tab)
    }
    url.search = searchObj;

    return url;
}

const colliOrdineMapper = (riga => {
    return {
        "lunghezza": riga.baseminima,
        "larghezza": riga.basemassima,
        "altezza": riga.altezza,
        "peso": riga.pesokg,
        "qta": riga.quantita,
        "naturamerce": riga.naturamerce.multiDescr.testo ?? riga.naturamerce.codice
    }
}) 

const spedizioneDaOrdineSync = (ordine) => {
    logger.debug("aggiunte le righe all'ordine", ordine); 

    /**
     * @type {import("../../model/IPreventivo").Preventivo}
     */
    let spedizione = {

        step: 1,

        tipoSelezionato: Number(ordine.tipospedizione.id),    
        valmerce: ordine.valmerce,
        colli: ordine.righe.map(colliOrdineMapper),                

        mittente: {...ordine.indirizzomittente, proponiper: ordine.indirizzomittente.proponiper.value},
        nazione_partenza: ordine.indirizzomittente.comune.nazione,
        comune_partenza: ordine.indirizzomittente.comune,
        cap_comune_partenza: ordine.indirizzomittente.comune.cap,
        comune_comune_partenza: ordine.indirizzomittente.comune.comune,

        destinatario: {...ordine.indirizzodestinatario, proponiper: ordine.indirizzodestinatario.proponiper.value},                
        nazione_arrivo: ordine.indirizzodestinatario.comune.nazione,                
        comune_arrivo: ordine.indirizzodestinatario.comune,
        cap_comune_arrivo: ordine.indirizzodestinatario.comune.cap,
        comune_comune_arrivo: ordine.indirizzodestinatario.comune.comune,
    }


    return spedizione;
}

/**
 * 
 * @param {import("./model/IOrdine").Ordine} ordine 
 * @returns 
 */
const spedizioneDaOrdine = async (ordine) => {

    
    const data = await orderDetail(ordine.id);
    ordine = {
        ...data.testataordine,
        righe: data.listaRighe,
        servizi: data.listaAddizionali
    }
    
    return spedizioneDaOrdineSync(ordine)
    
}

const tabsDettaglio = [
    {label: __t("stato"), comp: TabTracking},
    {label: __t("step1"), comp: TabStep1}, 
    {label: __t("prodottoeservizi"), comp: TabProdotto}, 
    {label: __t("datifatturazione"), comp: TabDatifatt}, 
    {label: __t("documenti"), comp: TabStampe},
    {label: __t("pagamenti"), comp: TabPagamenti}
];

export {orderHrefBuilder, colliOrdineMapper, spedizioneDaOrdine, spedizioneDaOrdineSync, defaultStatoMenu, tabsDettaglio}